(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("mbc-core"));
	else if(typeof define === 'function' && define.amd)
		define(["mbc-core"], factory);
	else if(typeof exports === 'object')
		exports["mbc-legend"] = factory(require("mbc-core"));
	else
		root["mbc-legend"] = factory(root["mbc-core"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 121);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),

/***/ 102:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 112:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNTAwIDE1MDAiPjxwYXRoIGQ9Ik02OTguNSA3OTguNWgxMDB2LTEwMGgtMTAwdjEwMHptLTMwMCAwaDEwMHYtMTAwaC0xMDB2MTAwem0zNTAtODAwYy00MTAgMC03NTAgMzQwLTc1MCA3NTBzMzQwIDc1MCA3NTAgNzUwIDc1MC0zNDAgNzUwLTc1MC0zNDAtNzUwLTc1MC03NTB6bTAgMTQwMGMtMzYwIDAtNjUwLTI5MC02NTAtNjUwczI5MC02NTAgNjUwLTY1MCA2NTAgMjkwIDY1MCA2NTAtMjkwIDY1MC02NTAgNjUwem0yNTAtNjAwaDEwMHYtMTAwaC0xMDB2MTAweiIvPjwvc3ZnPjwhLS0gbW9ybmluZ3N0YXItZGVzaWduLXN5c3RlbSB2MS4xNi4xIC0tPg=="

/***/ }),

/***/ 121:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(22);


/***/ }),

/***/ 22:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(102);

var _legend = __webpack_require__(68);

var _legend2 = _interopRequireDefault(_legend);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _legend2.default;

/***/ }),

/***/ 67:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var core = __webpack_require__(0);
var Utils = core.Utils;

/**
 * @method addItemsSVG
 * Creates svg items within legend on right side of chart
 * Key and Item name
 */
function addItemsSVG(params) {
    var names = [];
    var items = params.items;
    var firstPass;
    var lineHeight = 17;
    var keyPadding = 5;
    var linePadding = 3;
    var scatterplotYBuffer = 10;
    var timeSeriesNoValueLinePadding = 8;
    var wrapVars = {
        params: params,
        container: params.container,
        names: names,
        firstPass: firstPass
    };
    var rangeLength = items.length * lineHeight + keyPadding; //line height + padding
    var y = d3.scale.linear().range([0, rangeLength]);

    var isLineChart = function isLineChart() {
        return params.chartType === 'lineChart';
    };
    var isTimeSeries = function isTimeSeries() {
        return params.chartType === 'time-series';
    };
    var isScatterPlot = function isScatterPlot() {
        return params.chartType === 'scatterplot';
    };
    var isBubbleChart = function isBubbleChart() {
        return params.chartType === 'bubbleChart';
    };
    var isBenchmark = function isBenchmark(d) {
        return d.groupName === params.benchmarksDataSource;
    };
    var isBenchmarkFirst = function isBenchmarkFirst(d) {
        return d.index === -1 && params.showBenchmark;
    };

    items.selectAll("*").remove();
    items.enter().append("g").attr("class", function (d) {
        return d.name ? Utils.string.dashify(d.name) : Utils.string.dashify(d.displayName);
    }).classed("legend-item", true);

    if (isTimeSeries()) {
        var legendValuesFormat = Utils.string.convertDashToEnDash(params.legendValuesFormat);
        items.append("text").attr("class", function (d, i) {
            return "mbc-time-series_dataKey";
        }).attr("x", 0).text(function (d) {
            return d.displayName;
        }).call(wrap, wrapVars).attr("y", function (d, i) {
            var yValue = y(i) + lineHeight + lineHeight * i;
            yValue = yValue + keyPadding * i;
            if (items[0][i - 1]) {
                var valueLine = params.legendShowValue ? linePadding / 2 * lineHeight : 5.5;
                yValue = getElementY(items[0][i - 1], 0) + getNumTspan(items[0][i - 1], params.chartType) * lineHeight + linePadding + valueLine;
            }
            return yValue;
        });
        if (params.legendShowValue) {
            items.append("text").attr("class", "mbc-time-series_dataValue").attr("x", 0).attr("y", function (d, i) {
                var yValue = y(i) + lineHeight * 2 + lineHeight * i;
                yValue = yValue + keyPadding * i + 3;
                if (items[0][i]) {
                    yValue = getNumTspan(items[0][i], params.chartType) * lineHeight + linePadding + getElementY(items[0][i], 0);
                }
                return yValue;
            }).text(function (d) {
                names.push(legendValuesFormat(d.value));
                return legendValuesFormat(d.value);
            });
        }

        items.append("line").attr("x1", 0).attr("y1", function (d, i) {
            var yValue = y(i) + lineHeight * i;
            yValue = yValue + 5 * i;
            if (items[0][i - 1]) {
                var index = params.legendShowValue ? 1 : 0;
                var numLinesNoValue = params.legendShowValue ? 0 : getNumTspan(items[0][i - 1], params.chartType) * lineHeight - timeSeriesNoValueLinePadding;
                yValue = getElementY(items[0][i - 1], index) + numLinesNoValue + lineHeight / 2 * index;
            }
            return yValue;
        }).attr("x2", function (d) {
            var svg = params.container.append("svg");
            var largestWidth = parseInt(Utils.svg.getGreaterSVGTextWidth(svg, wrapVars.names)) + 21;
            svg.remove();
            var width = largestWidth - params.legendWidth >= 1 ? largestWidth : params.legendWidth - 1;
            return scrollbarPresent(wrapVars) ? width + 15 : width;
        }).attr("y2", function (d, i) {
            var yValue = y(i) + lineHeight * i;
            yValue = yValue + 5 * i;
            if (items[0][i - 1]) {
                var index = params.legendShowValue ? 1 : 0;
                var numLinesNoValue = params.legendShowValue ? 0 : getNumTspan(items[0][i - 1], params.chartType) * lineHeight - timeSeriesNoValueLinePadding;
                yValue = getElementY(items[0][i - 1], index) + numLinesNoValue + lineHeight / 2 * index;
            }
            return yValue;
        }).attr("stroke", function (d) {
            return d.color || params.colors[d.index % params.colors.length];
        }).attr("stroke-dasharray", function (d) {
            var lineIsDotted = params.dottedLines.indexOf(d.displayName) > -1;
            return lineIsDotted ? "2,2" : "transparent";
        }).attr("stroke-width", "2");
    } else {

        // Draw the text for all series and benchmark info
        items.append("text").attr("class", function (d, i) {
            return "dataName" + i;
        }).text(function (d) {
            if ((isScatterPlot() || isBubbleChart()) && d.index === -1) {
                return params.benchmarkLabel;
            }
            return d.displayName;
        }).attr("x", 15).call(wrap, wrapVars).attr("y", function (d, i) {
            var yValue = y(i) + 10;
            if (items[0][i - 1]) {
                yValue = getNumTspan(items[0][i - 1]) > yValue ? getNumTspan(items[0][i - 1]) : yValue;
            }
            if (isScatterPlot() || isBubbleChart()) {
                var yValue = y(i);
                if (items[0][i - 1]) yValue = getNumTspan(items[0][i - 1]) > 4 ? getNumTspan(items[0][i - 1]) - 4 : yValue;
                if (i == 0) yValue = params.showBenchmark ? yValue = yValue + 15 : yValue + 12;
                return yValue;
            }
            return yValue;
        }).on("mouseover", function (d) {
            if (isScatterPlot() || isBubbleChart()) {
                return params.showBenchmark && d.index === -1 ? params._this.legendBenchmarkMouseover.call(params._this, d, this) : params._this.legendMouseover.call(params._this, d, this);
            }
            return null;
        }).on("mouseout", function (d) {
            if (isScatterPlot() || isBubbleChart()) {
                return params.showBenchmark && d.index === -1 ? params._this.legendBenchmarkMouseout.call(params._this, d, this) : params._this.legendMouseout.call(params._this, d, this);
            }
            return null;
        });

        // Get the series without the benchmark
        var series = items.filter(function (d) {
            return d.groupName !== params.benchmarksDataSource;
        });

        // Only draw the line for the line chart
        if (isLineChart()) {
            series.append("line").attr("x1", 0).attr("y1", function (d, i) {
                var yValue = y(i) + 5;
                if (items[0][i - 1]) {
                    yValue = getNumTspan(items[0][i - 1]) > yValue ? getNumTspan(items[0][i - 1]) - 5 : yValue;
                }
                return yValue;
            }).attr("x2", 10).attr("y2", function (d, i) {
                var yValue = y(i) + 5;
                if (items[0][i - 1]) {
                    yValue = getNumTspan(items[0][i - 1]) > yValue ? getNumTspan(items[0][i - 1]) - 5 : yValue;
                }
                return yValue;
            }).attr("stroke-width", "2").attr("stroke", function (d, i) {
                return d.color || params.colors[i % params.colors.length];
            }).attr("stroke-dasharray", function (d) {
                if (params.lineStyles[d.displayName]) {
                    return "2,2";
                }
            });
        }

        // Only draw the rectangles for non-line charts like vertical-bar
        if (isScatterPlot() || isBubbleChart()) {
            // Get the series without the benchmark
            series = items.filter(function (d) {
                return params.showBenchmark ? d.index !== -1 : true;
            });
            if (params.showBenchmark) {
                d3.select(items[0][0]).append("rect").attr("x", 0).attr("y", function (d, i) {
                    return y(i) + 4;
                }).attr("width", 10).attr("height", 10).attr("fill", params.benchmarkColor).attr("fill-opacity", 0.8).on("mouseover", function (d) {
                    return params._this.legendBenchmarkMouseover.call(params._this, d, this);
                }).on("mouseout", function (d) {
                    return params._this.legendBenchmarkMouseout.call(params._this, d, this);
                });
            }

            series.append("circle").attr("cx", 5).attr("cy", function (d, i) {
                if (params.showBenchmark) i = i + 1;
                var yValue = y(i);
                if (items[0][i - 1]) yValue = getNumTspan(items[0][i - 1]) > 10 ? getNumTspan(items[0][i - 1]) - 10 : yValue;
                if (i == 0) yValue = params.showBenchmark ? yValue = yValue + 15 : yValue + 7;
                return yValue;
            }).attr("r", 5).attr("fill", function (d, i) {
                if (isBubbleChart()) return d.color || params.colors[i % params.colors.length];
                return params.scatterplotColors[d.groupIndex % params.scatterplotColors.length];
            }).attr("fill-opacity", 0.8).on("mouseover", function (d) {
                return params._this.legendMouseover.call(params._this, d, this);
            }).on("mouseout", function (d) {
                return params._this.legendMouseout.call(params._this, d, this);
            });
        }

        if (!isScatterPlot() && !isLineChart() && !isBubbleChart()) {
            // Only draw the rectangles for non-line charts like vertical-bar
            series.append("rect").attr("x", 0).attr("y", function (d, i) {
                var yValue = y(i);
                if (items[0][i - 1]) {
                    yValue = getNumTspan(items[0][i - 1]) > yValue ? getNumTspan(items[0][i - 1]) - 10 : yValue;
                }
                return yValue;
            }).attr("width", 10).attr("height", 10).attr("fill", function (d, i) {
                return d.color || params.colors[i % params.colors.length];
            }).attr("fill-opacity", 0.8);
        }
    }

    // Draw Just Benchmark
    var benchmarkPosition = items[0].length - 2; //Needed to correctly position the benchmark line relative to the data point legend values
    var benchmark = items.filter(function (d) {
        return d.groupName === params.benchmarksDataSource;
    });
    benchmark.append("line").attr("x1", 0).attr("y1", function (d, i) {
        var yValue = y(i) + 5;
        yValue = getNumTspan(items[0][benchmarkPosition]) > yValue ? getNumTspan(items[0][benchmarkPosition]) - 5 : yValue;
        return yValue;
    }).attr("x2", 10).attr("y2", function (d, i) {
        var yValue = y(i) + 5;
        yValue = getNumTspan(items[0][benchmarkPosition]) > yValue ? getNumTspan(items[0][benchmarkPosition]) - 5 : yValue;
        return yValue;
    }).attr("stroke", params.benchmarkColor).attr("stroke-width", "2");

    if (params.dottedBenchmark) {
        benchmark.attr("stroke-dasharray", "2,2");
    }

    items.exit().remove();

    adjustSVGHeight(params, items);
    setLegendWidth(wrapVars);
}

/**
 * @method addTopItemsSVG
 * Creates svg items within legend on top of chart
 * Key and Item name
 * Hides elements that scope beyond chart width
 */
function addTopItemsSVG(params) {
    var items = params.items;
    var iconWithPadding = 16;
    var horizontalIconPadding = 5;
    var overflowBtnWithSpace = 24;
    var isBenchmark = function isBenchmark(d) {
        return d.groupName === params.benchmarksDataSource;
    };
    var isBenchmarkFirst = function isBenchmarkFirst(d) {
        return d.index === -1 && params.showBenchmark;
    };
    var isLineChart = function isLineChart() {
        return params.chartType === 'lineChart';
    };
    var isTimeSeries = function isTimeSeries() {
        return params.chartType === 'time-series';
    };
    var isHorizontalBar = function isHorizontalBar() {
        return params.chartType === 'horizontalBar';
    };
    var isVerticalBar = function isVerticalBar() {
        return params.chartType === 'verticalBar';
    };
    var isLineTime = function isLineTime() {
        return isLineChart() || isTimeSeries();
    };
    var isScatterPlot = function isScatterPlot() {
        return params.chartType === 'scatterplot';
    };
    var isBubbleChart = function isBubbleChart() {
        return params.chartType === 'bubbleChart';
    };

    items.enter().append("g").attr("class", function (d) {
        return d.displayName ? Utils.string.dashify(d.displayName) : Utils.string.dashify(d.name);
    }).style("display", function (d, i) {
        var svg = params.container.append("svg");
        var textWidth = Utils.svg.getSVGTextWidth(svg, d.displayName);
        var containerWidth = params.legendWidth;
        svg.remove();
        var benchmarkWidth = params.showBenchmark ? Utils.svg.getSVGTextWidth(params.container, params.benchmarkLabel) : 0;
        i = params.showBenchmark ? i + 1 : i;
        var textX = getTotalItemsWidth(params.container, items[0].slice(0, i), 'displayName'); //item spacing + overflow button spacing and width
        if (isScatterPlot() || isBubbleChart()) {
            textX = textX + 40 + benchmarkWidth;
            containerWidth = containerWidth - 20;
        }
        textX = params.showBenchmark ? textX + horizontalIconPadding : textWidth + textX + i * iconWithPadding + iconWithPadding + overflowBtnWithSpace;
        return textX > containerWidth ? "none" : "";
    }).classed("legend-item", true);

    if (isScatterPlot() || isBubbleChart()) {
        var benchmarkWidth = params.showBenchmark ? Utils.svg.getSVGTextWidth(params.container, params.benchmarkLabel) : 0;
        var titleNode = items[0].parentNode.childNodes[0];
        // Get the series without the benchmark
        var series = items.filter(function (d) {
            return params.showBenchmark ? d.index !== -1 : true;
        });
        if (params.showBenchmark) {
            d3.select(items[0][0]).append("rect").attr("x", function (d, i) {
                var width = getTotalItemsWidth(params.container, items[0].slice(0, i), 'displayName');
                if (titleNode.className.baseVal === "mbc-legend-title") {
                    var titleWidth = titleNode.getBoundingClientRect().width;
                    width = width + titleWidth + 15;
                }
                if (i === 0) {
                    return width;
                }
                return width + i * iconWithPadding;
            }).attr("y", function (d, i) {
                return iconWithPadding / 4;
            }).attr("width", 10).attr("height", 10).attr("fill", params.benchmarkColor).attr("fill-opacity", 0.8).on("mouseover", function (d) {
                return params._this.legendBenchmarkMouseover.call(params._this, d, this);
            }).on("mouseout", function (d) {
                return params._this.legendBenchmarkMouseout.call(params._this, d, this);
            });
        }
        series.append("circle").attr("cx", function (d, i) {
            var start = 0;
            if (params.showBenchmark) {
                i = i + 1;
                start = 1;
            }
            var width = benchmarkWidth + getTotalItemsWidth(params.container, items[0].slice(start, i), 'displayName');
            if (titleNode.className.baseVal === "mbc-legend-title") {
                var titleWidth = titleNode.getBoundingClientRect().width;
                width = width + titleWidth;
            }
            if (i === 0) {
                return width + 18;
            }
            if (i === 1) {
                return params.showBenchmark ? width + i * iconWithPadding + 30 : width + i * iconWithPadding + 10;
            }
            if (i === 2) {
                return params.showBenchmark ? width + i * iconWithPadding + 24 : width + i * iconWithPadding + 4;
            }
            return params.showBenchmark ? width + i * iconWithPadding + 16 : width + i * iconWithPadding - 2;
        }).attr("cy", function () {
            return iconWithPadding / 2;
        }).attr("r", 5).attr("fill", function (d, i) {
            if (isBubbleChart()) return d.color || params.colors[i % params.colors.length];
            return isBenchmarkFirst(d) ? "transparent" : params.scatterplotColors[d.groupIndex];
        }).attr("fill-opacity", 0.8).on("mouseover", function (d) {
            return params._this.legendMouseover.call(params._this, d, this);
        }).on("mouseout", function (d) {
            return params._this.legendMouseout.call(params._this, d, this);
        });
        items.append("text").attr("x", function (d, i) {
            var start = params.showBenchmark ? 1 : 0;
            var width = params.showBenchmark && i === 0 ? 0 : benchmarkWidth + getTotalItemsWidth(params.container, items[0].slice(start, i), 'displayName');
            if (titleNode.className.baseVal === "mbc-legend-title") {
                var titleWidth = titleNode.getBoundingClientRect().width;
                width = width + titleWidth;
            }
            if (i === 0) return params.showBenchmark ? width + iconWithPadding + 15 : width + iconWithPadding + 11;
            if (i === 1) return params.showBenchmark ? width + i * iconWithPadding + 40 : width + i * iconWithPadding + 20;
            if (i === 2) return params.showBenchmark ? width + i * iconWithPadding + 34 : width + i * iconWithPadding + 14;
            return params.showBenchmark ? width + i * iconWithPadding + 26 : width + i * iconWithPadding + 8;
        }).attr("y", function () {
            return iconWithPadding - 3;
        }).text(function (d) {
            if (d.index === -1) {
                return params.benchmarkLabel;
            }
            return d.displayName;
        }).on("mouseover", function (d) {
            return params.showBenchmark && d.index === -1 ? params._this.legendBenchmarkMouseover.call(params._this, d, this) : params._this.legendMouseover.call(params._this, d, this);
        }).on("mouseout", function (d) {
            return params.showBenchmark && d.index === -1 ? params._this.legendBenchmarkMouseout.call(params._this, d, this) : params._this.legendMouseout.call(params._this, d, this);
        });
    }
    if (isHorizontalBar()) {
        items.append("rect").attr("x", function (d, i) {
            var width = getTotalItemsWidth(params.container, items[0].slice(0, i), 'displayName');
            return i === 0 ? width : width + (iconWithPadding - 3);
        }).attr("y", function (d, i) {
            return 0;
        }).attr("width", function (d, i) {
            return i === 1 ? 2 : 10;
        }).attr("height", function (d, i) {
            return 10;
        }).attr("fill", function (d, i) {
            if (i === 1) {
                return;
            }
            return params.colors[i % params.colors.length];
        }).attr("fill-opacity", function () {
            return 0.8;
        }).attr("stroke", function (d, i) {
            if (i === 0) {
                return;
            }
            return params.benchmarkColor;
        }).attr("stroke-width", "1");

        items.append("text").attr("x", function (d, i) {
            var width = getTotalItemsWidth(params.container, items[0].slice(0, i), 'displayName');
            if (i == 0) {
                return width + (iconWithPadding - 1);
            }
            return width + (iconWithPadding - 1) + horizontalIconPadding;;
        }).attr("y", 10).text(function (d) {
            return d.displayName;
        });
    }

    if (!isHorizontalBar() && !isScatterPlot() && !isBubbleChart()) {
        items.append("rect").attr("x", function (d, i) {
            var width = getTotalItemsWidth(params.container, items[0].slice(0, i), 'displayName');
            if (i == 0) {
                return width;
            }
            return width + i * iconWithPadding;
        }).attr("y", function (d, i) {
            return isBenchmark(d, i) || isLineTime() ? 4 : 0;
        }).attr("width", function (d, i) {
            return 10;
        }).attr("height", function (d, i) {
            return isBenchmark(d, i) || isLineTime() ? 1 : 10;
        }).attr("fill", function (d, i) {
            if (isBenchmark(d, i) || isLineTime()) {
                return "none";
            }
            return params.colors[i % params.colors.length];
        }).attr("fill-opacity", function () {
            return isVerticalBar() ? 0.8 : 1;
        }).attr("stroke", function (d, i) {
            if (isLineChart()) {
                return d.color || params.colors[i % params.colors.length];
            }
            if (isTimeSeries()) {
                return d.color || params.colors[d.index % params.colors.length];
            }
            if (isBenchmark(d, i)) {
                return params.benchmarkColor;
            }
            return;
        }).attr("stroke-dasharray", function (d, i) {
            if (isTimeSeries() && params.dottedLines.indexOf(d.displayName) > -1) {
                return "3,3";
            }
            if (params.lineStyles[d.displayName] || isBenchmark(d, i) && params.dottedBenchmark) {
                return "3,3";
            }
            return;
        }).attr("stroke-width", "1");

        items.append("text").attr("x", function (d, i) {
            var width = getTotalItemsWidth(params.container, items[0].slice(0, i), 'displayName');
            if (i == 0) {
                return width + (iconWithPadding - 1);
            }
            return width + i * iconWithPadding + (iconWithPadding - 1);
        }).attr("y", 10).text(function (d) {
            return d.displayName;
        });
    }
    items.exit().remove();
}

/**
 * @method getLegendWidth
 * Get Legend Width
 * @param container, @param data
 * @return {Number}
 */
function getTotalItemsWidth(container, data, accessor) {
    var svg = container.append("svg");
    var width = Utils.svg.getTotalSVGTextWidth(svg, data, accessor);
    svg.remove();
    return width;
}

/**
 * @method getNumTspan
 * Gets number of lines text element wraps to
 * Line returns next line y-position
 * Time Series returns number of lines for element
 * @param element, @param chartType
 * @return {Number}
 */
function getNumTspan(element, chartType) {
    var numLines = 1;
    var prevY = getElementY(element, 0);

    if (typeof element !== 'undefined') {
        numLines = element.childNodes[0].childNodes.length;
        if (chartType === 'time-series') {
            return numLines > 1 ? numLines : 1;
        }
    }
    return numLines * 17 + prevY + 5;
}

/**
 * @method getElementY
 * Gets y attribute of elements child i
 * @param element, @param i
 * @return {Number}
 */
function getElementY(element, i) {
    return typeof element !== 'undefined' ? parseFloat(d3.select(element.childNodes[i]).attr("y")) : 0;
}

/**
 * @method wrap
 * Wraps text to multiple lines as needed according to legend width
 * @param text, @param container
 */
function wrap(text, wrapVars) {
    var legendMaxWidth = 120;
    var scrollbarWidth = 17;
    var iconWithPadding = 21;
    text.each(function () {
        var text = d3.select(this),
            words = text.text().split(/\s+/).reverse(),
            word,
            line = [],
            lineHeight = 1,
            // ems
        x = text.attr("x"),
            y = text.attr("y"),
            tspan = text.text(null).append("tspan").attr("x", x).attr("y", y);
        if (words.length < 2) wrapVars.names.push(word);
        while (word = words.pop()) {
            line.push(word);
            tspan.text(line.join(" "));
            var scrollbar = scrollbarPresent(wrapVars) ? scrollbarWidth : 0;
            wrapVars.firstPass = scrollbarPresent(wrapVars);
            if (tspan.node().getComputedTextLength() + iconWithPadding + scrollbar > legendMaxWidth && line.length > 1) {
                line.pop();
                tspan.text(line.join(" "));
                wrapVars.names.push(line.pop());
                line = [word];
                tspan = text.append("tspan").attr("x", x).attr("y", y).attr("dy", 1 * lineHeight + 0.25 + "em").text(word);
                text.attr("id", "double");
                wrapVars.names.push(word);
            } else {
                wrapVars.names.push(line.join(" "));
            }
        }
    });
}

/**
 * @method adjustSVGHeight
 * Sets legend svg height according to last item in data
 * @param items
 * @return {Number}
 */
function adjustSVGHeight(params, items) {
    var parentID = params.parentID;
    var isTimeSeries = params.chartType === "time-series";
    var isBubbleChart = params.chartType === "bubbleChart";
    var lastElement = items[0][items[0].length - 1];
    var lastelemIndex = isTimeSeries && params.legendShowValue ? 1 : 0;
    var lastElementY = parseFloat(d3.select(lastElement.childNodes[lastelemIndex]).attr("y"));
    var lastElementH = lastElement.childNodes[lastelemIndex].getBoundingClientRect().height;
    var newLegendHeight = isTimeSeries ? lastElementH + lastElementY - 10 : lastElementH + lastElementY;
    var setLegendHeight = isBubbleChart ? newLegendHeight - 10 : newLegendHeight;
    d3.select("#svgcontainer_" + parentID).select("svg").attr("height", setLegendHeight);
}

/**
 * @method scrollbarPresent
 * Get Legend Height compare to chart height
 * @param container
 * @return {Number}
 */
function scrollbarPresent(wrapVars) {
    if (wrapVars.params.chartType === 'scatterplot' || wrapVars.params.chartType === 'bubbleChart') {
        return wrapVars.params._this._canvas.height() - 9 < wrapVars.params.container[0][0].children[1].children[1].children[0].clientHeight;
    }
    var svgContainerDiv = wrapVars.params.container[0][0].children[1].getElementsByClassName("mbc-legend")[0];
    var legendContainerHeight = parseFloat(wrapVars.params.container[0][0].children[1].style.height);
    return legendContainerHeight <= svgContainerDiv.clientHeight;
}

/**
* @method setLegendWidth
* Get Legend Width
* @param container, @param data
* @return {Number}
*/
function setLegendWidth(wrapVars) {
    var params = wrapVars.params;
    var parentID = params.parentID;
    var legendMaxWidth = 120;
    var scrollbarWidth = 17;
    var iconWithPadding = 21;
    var svg = params.container.append("svg");
    var width = parseInt(Utils.svg.getGreaterSVGTextWidth(svg, wrapVars.names)) + iconWithPadding; // icon and padding
    svg.remove();
    if (scrollbarPresent(wrapVars)) {
        //Scrollbar space
        if (wrapVars.params.chartType === 'scatterplot' || wrapVars.params.chartType === 'bubbleChart') {
            width = width + scrollbarWidth < legendMaxWidth ? width : legendMaxWidth - scrollbarWidth;
        } else {
            width = width < legendMaxWidth - scrollbarWidth && params.chartType !== 'time-series' ? legendMaxWidth - scrollbarWidth : width;
        }
    }
    width = width > legendMaxWidth ? legendMaxWidth : width;
    d3.select("#svgcontainer_" + parentID).select("svg").attr("width", width);

    if (scrollbarPresent(wrapVars) !== wrapVars.firstPass) {
        addItemsSVG(params);
    }
}

module.exports = {
    addItemsSVG: addItemsSVG,
    addTopItemsSVG: addTopItemsSVG
};

/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var mds_constants = __webpack_require__(7).constants;
var mds_space = mds_constants["space"];
var mds_size_icon = mds_constants["size"]["icon"];
var core = __webpack_require__(0);
var Utils = core.Utils;
var Classes = core.Classes;
var mds_constants = Utils.colors.mds_constants;
var drawSVG = __webpack_require__(67);
var icon_mds_ellipsis_circle_s = __webpack_require__(112);

function Legend() {}
/**
 * @class Legend
 * instantiates legend object with necessary variable and constants
 * defaultOptions consistent across charts unless otherwise defined in specific chart
 * @param options Contains any chart specific options declared in chart
 */
Legend.prototype.invokeLegend = function (options) {
    var canvas = this.get("canvas"),
        _this = this;
    options = options || {};
    this.__OPTIONS = options;

    var defaultOptions = {
        container: this.get("selection").select("." + Classes.LEGEND),
        legend: this.get("selection").select("." + Classes.LEGEND).select("." + Classes.LEGEND + "-inner"),
        data: this.get("data"),
        benchmark: this.get("data").get("benchmark"),
        benchmarkColor: this.get("benchmarksColor") || this.get("benchmarkColor"),
        benchmarkStyle: false,
        benchmarkSpan: "benchmark",
        mouseover: true
    };

    Utils.object.copy(defaultOptions, options);
    this._options = defaultOptions;

    // Variables
    this._canvas = canvas;
    if (this._isBubbleChart() && !this._options.container[0][0].parentElement) return;
    var parentClassList = this._options.container[0][0].parentElement.classList;
    var arr = [].slice.call(parentClassList);
    arr.forEach(function (pClass, idx) {
        if (pClass.indexOf('mbc_') >= 0) {
            _this.set('parentID', pClass);
        }
    });
    var parentID = this.get('parentID');
    this._container = this._options.container.attr("id", "svgcontainer_" + parentID);
    this._data = this._options.data;
    this._legend = this._options.legend;
    this._benchmarkColor = this._options.benchmarkColor;
    this._benchmarkStyle = this._options.benchmarkStyle;
    this._benchmarkSpan = this._options.benchmarkSpan;

    this._margin = canvas.get("margin");
    this._legendTitle = this.get("legendTitle");
    this._benchmarkLabel = this.get("benchmarkLabel");
    this._legendMaxWidth = this.get("legendMaxWidth");

    var id = "mbc-mds-popover--" + this.generateID();
    if (this.get('popoverID') == null) {
        _this.set('popoverID', id);
    }
    this._createLegend();
};

/**
 * @method _createLegend
 * Create legend div container
 * Includes the title
 */
Legend.prototype._createLegend = function () {
    var parentID = this.get('parentID');
    var _this = this;
    if (this._options.chart === "horizontalBar") {
        var child = this._container[0][0].children;
        var arr = [].slice.call(child);
        if (typeof arr !== 'undefined') {
            arr.forEach(function (gElem) {
                gElem.parentElement.removeChild(gElem);
            });
        }
        var legendInner = _this.get("selection").select(".mbc-chart-legend").append('div').attr('class', Classes.LEGEND + "-container");
        this._container.style({
            "margin-left": this._canvas.get("margin").left + "px",
            "margin-right": "30px",
            "margin-top": this._canvas.get("margin").top + "px",
            "margin-bottom": "-30px"
        });
        if (this._options.orient === "top") this._container.style({ "margin-bottom": -20 + "px" });
        if (this._options.orient === "bottom") this._container.style({ "margin-bottom": -30 + "px" });
    } else {
        if (this._isScatterPlot()) {
            var child = this._container[0][0].children;
            var arr = [].slice.call(child);
            if (typeof arr !== 'undefined') {
                arr.forEach(function (gElem) {
                    gElem.parentNode.removeChild(gElem);
                });
            }
        } else {
            this._legend.remove();
        }

        this._setLegendHeightWidth();
        this.getDottedLines();
    }

    if (this._isVerticalBar() || this._options.chart === "lineChart" || this._options.chart === "time-series" || this._options.chart === "horizontalBar" || this._isScatterPlot() || this._isBubbleChart()) {
        var id = this.get('popoverID');
        var iconBtn = document.getElementsByClassName('mbc-mds-popover__trigger');
        var child = this._container[0][0].parentElement.children;
        var arr = [].slice.call(child);
        arr.forEach(function (div) {
            d3.select(div).attr('popoverID', id);
        });
        this.makeSVGContainer();
        this.drawSVGLegend();
        if (this._options.chart !== "horizontalBar") this.adjustLegendWidth(parseFloat(d3.select("#svgcontainer_" + parentID).select("svg").attr("width")));
        if (iconBtn != null && iconBtn.length > 0) this.setPopoverPosition(id);
        if (this._isScatterPlot() && this._container[0][0].childNodes[0] && this._container.classed(Classes.LEGEND + "-right")) {
            var chartLayerHeight = this._canvas.layer("y-axis", "axes")[0][0].getBoundingClientRect().height;
            var legendInnerDiv = this._container[0][0].childNodes[0];
            var style = legendInnerDiv.currentStyle || window.getComputedStyle(legendInnerDiv);
            d3.select(this._container[0][0]).style('height', chartLayerHeight - 6 + "px");
            d3.select(this._container[0][0].childNodes[1]).style('height', chartLayerHeight - 26 + "px");
        }
    } else {
        this._addLegendItems();
    }

    // removes empty elements from inner chart svg
    // from:https://github.com/jserz/js_piece/blob/master/DOM/ChildNode/remove()/remove().md
    if (d3.select("." + Classes.LEGEND + "-inner").selectAll(".legend-item") !== null) {
        var arr = d3.select("." + Classes.LEGEND + "-inner").selectAll(".legend-item");
        if (typeof arr[0] !== 'undefined') {
            arr[0].forEach(function (gElem) {
                if (gElem.hasOwnProperty('remove') && gElem.childNodes.length === 0) {
                    gElem.remove();
                }
                // for IE remove polyfill
                if (!gElem.hasOwnProperty('remove') && gElem.childNodes.length === 0) {
                    Object.defineProperty(gElem, 'remove', {
                        configurable: true,
                        enumerable: true,
                        writable: true,
                        value: function remove() {
                            if (this.parentNode !== null) this.parentNode.removeChild(this);
                        }
                    });
                }
            });
        }
    }
};

/**
 * @method makeSVGContainer
 * Create svg legend container
 * Includes width and height
 */
Legend.prototype.makeSVGContainer = function () {
    var legendWidth = this.get("legendWidth");
    var parentID = this.get('parentID');
    var textWidth = this._container.classed(Classes.LEGEND + "-right") ? legendWidth : this._container[0][0].offsetWidth - 20; // padding left + icon margin + icon width vertical
    var legendHeight = this._container[0][0].offsetHeight - this._margin.bottom - this._margin.top - 1; // subtract 1 to align bottom rule

    if (this._legend[0][0] && legendHeight < this._legend[0][0].scrollHeight) {
        //Scrollbar space
        textWidth += 12;
    }
    this.set("legendWidth", textWidth);

    var svgHeight = legendHeight > this._data.length * 22 + 5 ? legendHeight : this._data.length * 22 + 5;
    var numHeight = this._container.classed(Classes.LEGEND + "-right") ? svgHeight : 20; // 17 line height + 5 padding
    var innerLegendSelector = document.querySelector("#svgcontainer_" + parentID);
    if (this._isScatterPlot()) {
        if (this._container.classed(Classes.LEGEND + "-right")) {
            d3.select(innerLegendSelector).style("padding-top", "5px");
            d3.select(innerLegendSelector).style("margin-top", "4px");
        }
    }
    if (this._container.classed(Classes.LEGEND + "-right")) {
        if (this._isScatterPlot() || this._isBubbleChart()) {
            var titleLabel = d3.select(innerLegendSelector).append("span").classed("mbc-legend-title", true);
            titleLabel.html(this.get("legendTitle"));
            innerLegendSelector = d3.select(innerLegendSelector).append("div").attr('class', 'mbc-legend-svg').style('overflow', 'auto');
        }
    }
    if (this._options.chart === "horizontalBar") {
        numHeight = 41;
        innerLegendSelector = document.querySelector("#svgcontainer_" + parentID).children[0];
    }
    innerLegendSelector = innerLegendSelector[0] ? innerLegendSelector[0][0] : innerLegendSelector;
    var svg = d3.select(innerLegendSelector).append("svg").attr("role", "legend").attr("class", "mbc-legend").attr("height", numHeight + "px");
    this.set("legendSVG", svg);
};

Legend.prototype.getDottedLines = function () {
    var arr = [].slice.call(this._data);
    var dotted = this.get("dottedLineNames");
    var lineStyles = {};
    arr.forEach(function (data, idx) {
        if (dotted) {
            var group = data.groupName;
            var name = data.displayName;
            var dottedLineNames = !(group === "benchmark") ? dotted[group] : null;
            lineStyles[name] = dottedLineNames;
        }
    });
    this.set('lineStyles', lineStyles);
};

/**
 * @method drawSVGLegend
 * Adds legend items to svg container
 * Includes right and top positioning
 */
Legend.prototype.drawSVGLegend = function () {
    var y1Axis = this.get("axes").axis("y1") || this.get("axes").axis("y");
    this._clearPopoversOverlays();
    var legendSVG = this.get("legendSVG");
    var legendWidth = this.get("legendWidth");
    var isTimeSeries = this._options.chart === "time-series";
    var isScatterPlot = this._options.chart === "scatterplot";
    if (legendSVG[0][0].childNodes.length < 1) {
        this.set("legendfrontGroup", legendSVG.append("g").classed(Classes.LEGEND + "-inner", true));
    }
    if (isTimeSeries) {
        this._data = this._sortLegendData();
    }
    if (this._isBubbleChart()) this._data = this.get("benchmark") ? this._options.benchmark.concat(this._data) : this._data;
    if (isScatterPlot) {
        var spData = this.get("data").get("scatterplot");
        this._color(0); //run colors to set scatterplotColors
        if (this.get("benchmark") && this._options.benchmark) {
            this._data = this._options.benchmark.concat(spData);
        }
    }
    var endPadding = legendWidth - 6; // SVG specific '7' - padding + borders
    var innerGroup = this.get("legendfrontGroup");
    var items = innerGroup.selectAll(".legend-item").data(this._data);
    var benchmarkColor = this.get("benchmarksColor") || this.get("benchmarkColor");
    var dottedBenchmark = this.get("dottedBenchmarks");
    var dottedLines = this.get('dottedLines');
    var colors = this.get("colors");
    var scatterColors = this.get('scatterplotColors');
    var showBenchmark = this.get("_showBenchmark") || this._isBubbleChart() && this.get('benchmark');
    var benchmarkLabel = this.get("benchmarkLabel");
    var legendWidth = this.get("legendWidth");
    var legendValuesFormat = this.get("legendValuesFormat");
    var legendShowValue = this.get("showLegendValues");
    var benchMarksVisible = this.get("benchMarksVisible");
    var parentID = this.get('parentID');
    var lineStyles = this.get('lineStyles');
    var chartType = this._options.chart;
    var benchmarksDataSource = this.get('benchmarksDataSource');
    var legendContainer = typeof container !== "undefined" ? container : this.get("selection");
    var params = {
        _this: this,
        items: items,
        endPadding: endPadding,
        benchmarkColor: benchmarkColor,
        dottedBenchmark: dottedBenchmark,
        dottedLines: dottedLines,
        colors: colors,
        scatterplotColors: scatterColors,
        legendWidth: legendWidth,
        legendValuesFormat: legendValuesFormat,
        legendShowValue: legendShowValue,
        container: legendContainer,
        parentID: parentID,
        chartType: chartType,
        lineStyles: lineStyles,
        showBenchmark: showBenchmark,
        benchmarkLabel: benchmarkLabel,
        benchmarksDataSource: benchmarksDataSource
    };

    if (y1Axis || this._isBubbleChart()) {
        if (this._container.classed(Classes.LEGEND + "-right")) {
            drawSVG.addItemsSVG(params);
            var id = this.get('popoverID');
            if (document.getElementById(id) !== null) {
                document.getElementById(id).parentElement.classList.remove('mbc-mds-popover__wrapper--visible');
                if (document.querySelector('[data-mbc-mds-popover="' + id + '"]') !== null) {
                    document.querySelector('[data-mbc-mds-popover="' + id + '"]').setAttribute('aria-expanded', 'false');
                }
            }
        } else {
            if (isScatterPlot || this._isBubbleChart()) {
                innerGroup.append('text').attr('class', "mbc-legend-title").attr("x", 0).attr("y", 13).text(this._legendTitle);
            }
            if (this._options.chart !== "horizontalBar") {
                drawSVG.addTopItemsSVG(params);
                this.createLegendPopoverSVG();
            }
        }
    }
    if (this._options.chart === "horizontalBar") {
        var legendInner = this.get("selection").select(".mbc-chart-legend");
        params.legendFundName = this.get("legendFundName");
        params.legendBenchmarkName = this.get("legendBenchmarkName");
        params.benchmarkColor = this._options.benchmarkColor;
        var legendData = benchMarksVisible ? [{ 'name': 'legendFundName', 'displayName': this.get("legendFundName") }, { 'name': 'legendBenchmarkName', 'displayName': this.get("legendBenchmarkName") }] : [{ 'name': 'legendFundName', 'displayName': this.get("legendFundName") }];
        params.items = innerGroup.selectAll(".legend-item").data(legendData);
        d3.select(innerGroup[0][0]).attr("transform", "translate(0, 17)");
        drawSVG.addTopItemsSVG(params);
        this.createLegendPopoverSVG();
        var legendDivWidth = document.getElementById("svgcontainer_" + parentID).clientWidth;
        d3.select(document.getElementById("svgcontainer_" + parentID).children[0].children[0]).attr("width", legendDivWidth - 8); //set legend svg elem to legend div width
    }
};

/**
 * @method _clearPopoverWrapperOverlays
 * Removes existed popover wrappers and overlays
 */
Legend.prototype._clearPopoversOverlays = function () {
    if (document.getElementsByClassName('mbc-mds-popover__overlay').length != 0) {
        var overlays = document.getElementsByClassName('mbc-mds-popover__overlay');
        var arr = [].slice.call(overlays);
        arr.forEach(function (overlay) {
            overlay.parentElement.removeChild(overlay);
        });
    }
    if (document.getElementsByClassName('mbc-mds-popover').length != 0) {
        var popovers = document.getElementsByClassName('mbc-mds-popover');
        var arr = [].slice.call(popovers);
        arr.forEach(function (popover) {
            popover.parentElement.removeChild(popover);
        });
    }
};

/**
 * @method _addLegendItems
 * Add Items to legend container both benchmark and data
 * sets identifier and styles for items
 * maintains current chart specific css
 */
Legend.prototype._addLegendItems = function (container) {
    var _this = this;
    var enter;
    var isTimeSeries = this._options.chart === "time-series";
    var mainDiv = container !== null && typeof container !== 'undefined' ? container : this._legend;
    var horizontalBarData = this.get("benchMarksVisible") ? [{ 'name': 'legendFundName', 'displayName': this.get("legendFundName") }, { 'name': 'legendBenchmarkName', 'displayName': this.get("legendBenchmarkName") }] : [{ 'name': 'legendFundName', 'displayName': this.get("legendFundName") }];

    if (this.get("benchmark") && this._options.benchmark) {
        this._data = this._data[0] !== this.get("data").get("benchmark")[0] ? this.get("data").get("benchmark").concat(this._data) : this._data;
    }

    if (isTimeSeries) {
        this._data = this._sortLegendData();
    }

    var isLineBenchmark = function isLineBenchmark(d) {
        return _this._isVerticalBar() && d.index === -1;
    };

    var isHorizontalBarBenchmark = function isHorizontalBarBenchmark(i) {
        return _this._options.chart === "horizontalBar" && i === 1;
    };

    var isBenchmarkFirst = function isBenchmarkFirst(d) {
        return d.index === -1 && _this.get("_showBenchmark");
    };

    var lineStyle = function lineStyle(d) {
        var dottedLines = _this.get('dottedLines');
        var color = _this._color(d.index);
        var lineIsDotted = dottedLines.indexOf(d.displayName) > -1;
        var style = lineIsDotted ? "2px dotted " + color : "2px solid " + color;
        return style;
    };
    var popOverData = this._options.chart === "horizontalBar" ? horizontalBarData : this._data;
    enter = d3.select(mainDiv[0][0]).selectAll("div").data(popOverData).enter().append("div").attr("class", function (d) {
        return d.displayName ? Utils.string.dashify(d.displayName) : Utils.string.dashify(d.name);
    }).classed("mbc-chart-legend-item", true);
    if (this._options.mouseover && this._options.chart !== "horizontalBar") {
        enter.on("mouseover", function (d) {
            isBenchmarkFirst(d) ? _this.legendBenchmarkMouseover(d) : _this.legendMouseover(d);
        }).on("mouseout", function (d) {
            isBenchmarkFirst(d) ? _this.legendBenchmarkMouseout(d) : _this.legendMouseout(d);
        });
    }
    if (isTimeSeries && this._container.classed(Classes.LEGEND + "-right")) {
        var legendValuesFormat = Utils.string.convertDashToEnDash(this.get("legendValuesFormat"));

        enter.append("p").attr("class", Classes.LEGEND_ITEM + "__label--right").text(function (d) {
            return d.displayName;
        }).style("border-top", function (d) {
            return lineStyle(d);
        }.bind(this));

        if (this.get("showLegendValues")) {
            enter.append("p").attr("class", Classes.LEGEND_ITEM + "__value--right").text(function (d) {
                return legendValuesFormat(d.value);
            });
        }
    } else {

        enter.append("span").classed(this._benchmarkSpan, function (d, i) {
            return isBenchmarkFirst(d) || isLineBenchmark(d);
        }).classed('horiz-bar-benchmark', function (d, i) {
            return isHorizontalBarBenchmark(i);
        }).classed(this._benchmarkSpan + "--dotted", function (d) {
            return isLineBenchmark(d) && this._benchmarkStyle;
        }).classed(Classes.LEGEND_ITEM + "__key", function (d) {
            return isTimeSeries;
        }).classed("square", function (d, i) {
            return _this._isVerticalBar() && !isLineBenchmark(d) || _this._isScatterPlot() && isBenchmarkFirst(d) || _this._isBubbleChart() && isBenchmarkFirst(d) || _this._options.chart === "horizontalBar" && i === 0;
        }).classed("circle", function (d) {
            return (_this._isScatterPlot() || _this._isBubbleChart()) && d.index !== -1;
        }).style("background-color", function (d, i) {
            if (isTimeSeries) {
                return 'transparent';
            }
            if (isLineBenchmark(d) || isHorizontalBarBenchmark(i)) {
                return this._benchmarkStyle ? 'transparent' : this._benchmarkColor;
            }
            if (isBenchmarkFirst(d)) {
                return this._benchmarkColor;
            }
            if (this._isScatterPlot() || this._isBubbleChart()) {
                return this._color(d.groupIndex);
            }
            return !this._isDottedLine(d.groupName, d.displayName) ? this._color(i) : null;
        }.bind(this)).style("border-top", function (d, i) {
            if (isLineBenchmark(d) && this._benchmarkStyle) {
                return "2px dotted " + this._benchmarkColor;
            }
            return this._isDottedLine(d.groupName, d.displayName) ? "2px dotted " + this._color(i) : null;
        }.bind(this)).style("border-bottom", function (d) {
            if (isTimeSeries) {
                return lineStyle(d);
            }
            return null;
        }.bind(this)).style("opacity", this.get("opacity"));

        enter.append("p").text(function (d) {
            return isBenchmarkFirst(d) && d.index === -1 ? _this._benchmarkLabel : d.displayName;
        });
    }
};

/**
 * @method generateID
 * Returns 5 digit id for legend popover created
 */
Legend.prototype.generateID = function () {
    return Math.floor(Math.random() * 90000) + 10000;
};

/**
 * @method addPopoverContent
 * Sets title and adds legend items to popover
 * @param id ID of popover generated at instantiation
 */
Legend.prototype.addPopoverContent = function (id) {
    var popOverElem = document.getElementById(id);
    if (popOverElem.getElementsByClassName("mbc-mds-popover__header").length !== 0) {
        var currentHeader = popOverElem.getElementsByClassName("mbc-mds-popover__header");
        currentHeader[0].parentNode.removeChild(currentHeader[0]);
    }
    if (popOverElem.getElementsByClassName("mbc-mds-popover__content").length !== 0) {
        var oldContent = popOverElem.getElementsByClassName("mbc-mds-popover__content");
        oldContent[0].parentNode.removeChild(oldContent[0]);
    }
    var headerElem = d3.select(popOverElem).append('header').attr('class', 'mbc-mds-popover__header');
    var titleElem = headerElem.append('h2').attr('class', 'mbc-mds-popover__title');
    titleElem[0][0].innerHTML = "Legend";

    var contentElem = d3.select(popOverElem).append('div').attr('class', 'mbc-mds-popover__content').style('overflow', 'auto');
    var chartInners = document.getElementsByClassName('mbc-chart-inner');
    var chartTop = document.getElementsByClassName('mbc-chart-inner')[0].getBoundingClientRect().top;
    var arr = [].slice.call(chartInners);
    arr.forEach(function (inner) {
        if (d3.select(inner).attr('popoverID') == id) {
            chartTop = inner.getBoundingClientRect().top;
        }
    });
    var legendMax = window.innerHeight - chartTop - headerElem[0][0].clientHeight;
    var calcMax = legendMax - 120 < 120 ? 120 : legendMax - 120;
    var maxHeight = calcMax > 250 ? 250 : calcMax;
    contentElem[0][0].style.maxHeight = maxHeight + "px"; //minus container bottom padding and title
    this._addLegendItems(contentElem);
};

/**
 * @method createOverlayDismiss
 * Adds popover overlay for dismissal
 * @param parentID ID of popover chart parent to get popover wrapper
 */
Legend.prototype.createOverlayDismiss = function (id) {
    var popoverParentSelector = this.get('legendPopoverParentElement');
    var popoverParent = document.querySelector(popoverParentSelector);
    if (popoverParent === null) {
        console.error("Chart parameter legendPopoverParentElement must be a class or id selector, invalid value is '%s'", popoverParentSelector);
    }
    var overLay = document.createElement('div');
    overLay.setAttribute('class', "mbc-mds-popover__overlay mbc-overlay_" + id);
    overLay.style.width = '100%';
    overLay.style.height = '100%';
    overLay.style.display = 'block';
    overLay.addEventListener('click', function () {
        var popovers = document.querySelectorAll('.mbc-mds-popover');
        for (var m = 0; m < popovers.length; m++) {
            // Close currently opened popovers outside of current selected
            popovers[m].classList.remove('mbc-legend-popover--visible');
            popoverParent.removeChild(popovers[m]);
            var arr = [].slice.call(popovers[m].classList);
            arr.forEach(function (popOverClass) {
                if (popOverClass.indexOf('mbc-mds-legend-popover_') >= 0) {
                    var chartClass = popOverClass.substring(popOverClass.indexOf('_') + 1);
                    if (document.getElementsByClassName(chartClass)[0].children[0].classList.contains(Classes.LEGEND + "-top")) {
                        document.querySelector('[data-mbc-mds-popover="' + popovers[m].id + '"]').setAttribute('aria-expanded', 'false');
                    }
                }
            });
        }
        popoverParent.removeChild(overLay);
    }, false);
    popoverParent.appendChild(overLay);
};

/**
 * @method createLegendPopoverSVG
 * Build MDS popover using MDS icon see docs
 * http://designsystem.morningstar.com/components/popovers.html#css-class-references
 * http://designsystem.morningstar.com/visual-language/iconography.html
 */
Legend.prototype.createLegendPopoverSVG = function () {
    var id = this.get('popoverID');
    var parentID = this.get('parentID');
    var _this = this;
    var popoverParentSelector = this.get('legendPopoverParentElement');
    var popoverParent = document.querySelector(popoverParentSelector);
    this._container.style('overflow', 'visible');
    this._container.style('position', 'relative');

    if (document.querySelector('[data-mbc-mds-popover="' + id + '"]')) {
        document.querySelector('[data-mbc-mds-popover="' + id + '"]').parentNode.removeChild(document.querySelector('[data-mbc-mds-popover="' + id + '"]'));
    }
    var buttonTop = this._options.chart === "horizontalBar" ? this._canvas.get("margin").top - 5 + "px" : '0px';
    buttonTop = this._isBubbleChart() ? 10 + "px" : buttonTop;
    var buttonDiv = this._container.append('button').attr('class', "mbc-mds-button mbc-mds-button--small mbc-mds-popover__trigger mbc-mds-button--icon-only").attr('type', 'button').attr('data-mbc-mds-popover', id).style('top', buttonTop).style('right', '6px').style('position', 'absolute').style('visibility', 'hidden').attr('aria-controls', id).attr('aria-haspopup', "true").attr('aria-expanded', 'false');
    var btnImage = buttonDiv.append("svg").attr("class", "mbc-mds-icon--s mbc-mds-button__icon");
    btnImage.attr('viewBox', '0 0 1500 1500').append('path').attr('d', 'M698.5 798.5h100v-100h-100v100zm-300 0h100v-100h-100v100zm350-800c-410 0-750 340-750 750s340 750 750 750 750-340 750-750-340-750-750-750zm0 1400c-360 0-650-290-650-650s290-650 650-650 650 290 650 650-290 650-650 650zm250-600h100v-100h-100v100z'); // draws ellipses icon from morningstar-design-system/dist/src/icons/ellipsis-circle--s.svg

    if (document.querySelector('[data-mbc-mds-popover="' + id + '"]')) {
        document.querySelector('[data-mbc-mds-popover="' + id + '"]').addEventListener('click', function () {
            var popOver = document.getElementById(id);
            if (popOver === null) {
                popOver = document.createElement('div');
                popOver.setAttribute('id', "" + id);
                popOver.setAttribute('class', "mbc-mds-popover mbc-mds-popover--width-200px mbc-mds-legend-popover_" + parentID);
                popOver.setAttribute('role', 'tooltip');
                popoverParent.appendChild(popOver);
            }

            _this.addPopoverContent(id);
            var popOverElem = document.getElementById(id);
            var popovers = document.querySelectorAll('.mbc-mds-popover');
            for (var m = 0; m < popovers.length; m++) {
                // Close currently opened popovers outside of current selected
                if (!popovers[m].isSameNode(popOverElem)) {
                    popovers[m].classList.remove('mbc-legend-popover--visible');
                    document.getElementsByClassName("" + parentID)[0].getElementsByClassName('mbc-mds-button--icon-only')[0].setAttribute('aria-expanded', 'false');
                }
            }
            var setPopover = _this.setPopoverPosition(id);
            setPopover.setPosition(popOverElem);
            popOverElem.classList.add('mbc-legend-popover--visible'); // Open currently selected popover
            document.querySelector('[data-mbc-mds-popover="' + id + '"]').setAttribute('aria-expanded', 'true');
            _this.createOverlayDismiss(id);
        });
    }
    this.showOverflowBtn(id);
};

/**
 * @method showOverflowBtn
 * Sets MDS popover wrapper to visible which shows only button in unselected state
 */
Legend.prototype.showOverflowBtn = function (id) {
    var parentID = this.get('parentID');
    var chartContainerElem = document.getElementsByClassName("" + parentID);
    var currentInner = chartContainerElem[0].getElementsByClassName('mbc-chart-legend-inner');

    if (currentInner[0].lastElementChild.style.display === 'none') {
        document.querySelector('[data-mbc-mds-popover="' + id + '"]').style.visibility = 'visible';
    }
};

/**
 * @method setPopoverPosition
 * Sets position of popovers on window scroll
 * Based on current overflow btn position and chart container position in window
 * @param id ID of popover generated at instantiation
 */
Legend.prototype.setPopoverPosition = function (id) {
    var _this = this;
    var parentID = this.get('parentID');
    var popoverWidth = 200;
    var currentPopover = document.getElementById(id);
    var popovers = document.querySelectorAll('.mbc-mds-popover');
    var chartContainerElem = document.getElementsByClassName("" + parentID);

    var iconBtns = document.querySelectorAll('.mbc-mds-popover__trigger');
    if (iconBtns.length > 0) {
        setPosition(currentPopover);
        window.onscroll = function () {
            var arr = [].slice.call(popovers);
            arr.forEach(function (popOverElem) {
                setPosition(popOverElem);
                if (!(popOverElem.getBoundingClientRect().top >= 0 || popOverElem.getBoundingClientRect().bottom >= 0) || !(popOverElem.getBoundingClientRect().left >= 0 || popOverElem.getBoundingClientRect().right >= 0)) {
                    //if out of viewport then remove popover and overlay
                    var popoverParentSelector = _this.get('legendPopoverParentElement');
                    var popoverParent = document.querySelector(popoverParentSelector);
                    var overLay = document.querySelector(".mbc-overlay_" + popOverElem.id);
                    var popoverBtn = document.querySelector('[data-mbc-mds-popover="' + popOverElem.id + '"]');
                    popOverElem.classList.remove('mbc-legend-popover--visible');
                    popoverBtn.blur();
                    popoverParent.removeChild(popOverElem);
                    popoverParent.removeChild(overLay);
                    popoverBtn.setAttribute('aria-expanded', 'false');
                }
            });
        };
    }

    function setPosition(popOverElem) {
        if (typeof popOverElem !== 'undefined' && popOverElem !== null) {
            var chartElem = chartContainerElem[0];
            var arr = [].slice.call(popOverElem.classList);
            arr.forEach(function (popOverClass) {
                if (popOverClass.indexOf('mbc-mds-legend-popover_') >= 0) {
                    var chartClass = popOverClass.substring(popOverClass.indexOf('_') + 1);
                    chartElem = document.querySelector("." + chartClass);
                }
            });
            if (popOverElem !== null && chartElem.children[0].classList.contains(Classes.LEGEND + "-top") || _this._options.chart === "horizontalBar") {
                removePopoverPosition(popOverElem);

                var iconBtn = document.querySelector('[data-mbc-mds-popover="' + popOverElem.id + '"]');
                var bodyRect = document.body.getBoundingClientRect(),
                    btnRect = iconBtn.getBoundingClientRect(),
                    offsetTop = btnRect.top - bodyRect.top,
                    offsetLeft = btnRect.left - bodyRect.left,
                    popOverHeight = popOverElem.getBoundingClientRect().height;

                if (window.innerWidth - iconBtn.getBoundingClientRect().right >= popoverWidth) {
                    //room on right of icon
                    popOverElem.style.top = offsetTop + iconBtn.getBoundingClientRect().height / 2 + "px";
                    popOverElem.style.left = offsetLeft + iconBtn.getBoundingClientRect().width + "px";
                    popOverElem.classList.add('mbc-mds-popover--right-bottom');
                    return;
                }

                if (iconBtn.getBoundingClientRect().top >= popOverElem.getBoundingClientRect().height) {
                    //room top of icon
                    popOverElem.style.top = offsetTop - popOverHeight - iconBtn.getBoundingClientRect().height / 2 + "px";
                    popOverElem.style.left = offsetLeft - popoverWidth + iconBtn.getBoundingClientRect().width / 2 + "px";
                    popOverElem.style.bottom = 'auto';
                    popOverElem.classList.add('mbc-mds-popover--top-left');
                    return;
                }

                popOverElem.style.top = offsetTop + iconBtn.getBoundingClientRect().height + "px";
                popOverElem.style.left = offsetLeft - popoverWidth + iconBtn.getBoundingClientRect().width / 2 + "px";
                popOverElem.classList.add('mbc-mds-popover--bottom-left');
            }
        }
    }
    return {
        setPosition: setPosition
    };

    function removePopoverPosition(popOverElem) {
        popOverElem.removeAttribute("style");
        if (popOverElem.classList.contains('mbc-mds-popover--top-left')) {
            popOverElem.classList.remove('mbc-mds-popover--top-left');
        }
        if (popOverElem.classList.contains('mbc-mds-popover--bottom-left')) {
            popOverElem.classList.remove('mbc-mds-popover--bottom-left');
        }
        if (popOverElem.classList.contains('mbc-mds-popover--right-bottom')) {
            popOverElem.classList.remove('mbc-mds-popover--right-bottom');
        }
        if (popOverElem.classList.contains('mbc-mds-popover--left-bottom')) {
            popOverElem.classList.remove('mbc-mds-popover--left-bottom');
        }
    }
};

/**
 * @method getLegendWidth
 * Get Legend Width
 * @param container, @param data
 * @return {Number}
 */
Legend.prototype.getLegendWidth = function (container, data) {
    var svg = container.append("svg");
    var width = Utils.svg.getGreaterSVGTextWidth(svg, data, "displayName");
    svg.remove();
    return width;
};

Legend.prototype.getItemsWidth = function (container, data) {
    var svg = container.append("svg");
    var width = Utils.svg.getTotalSVGTextWidth(svg, data, "displayName");
    svg.remove();
    return width;
};

/**
 * @method _setLegendHeightWidth
 * Set Legend width/height
 * Set Chart Container Width/Height
 * based on 'right' or 'top' attribute of legend container
 */
Legend.prototype._setLegendHeightWidth = function () {
    var chartContainer = this._canvas.get("container");
    var textWidth = this.getLegendWidth(this._container, this._data) + 15 + 6; // padding left + icon margin + icon width
    var legendHeight = this._container[0][0].offsetHeight - this._margin.bottom - this._margin.top - 1; // subtract 1 to align bottom rule
    var marginLeft = 0;

    this.set("legendHeight", legendHeight);
    this.adjustLegendWidth(textWidth);

    if (!this._container.classed(Classes.LEGEND + "-right")) {
        //When legend is placed at top of chart
        legendHeight = this._container[0][0].offsetHeight;
        marginLeft = this.get("yAxisOrient") === "left" ? this.get("yAxesLabelWidth") + this.get("yAxesLabelPadding") : 0;
        if (this._isBubbleChart()) marginLeft = this.checkViewIsGrid() ? marginLeft : 0;

        this._container.style("margin-left", marginLeft + "px");

        if (this._data.length > 0 && this._data[0].groupName !== "benchmark" && !this._isBubbleChart()) {
            var yAxesWidth = this.get("yAxesLabelWidth");
            if (this._isScatterPlot()) {
                yAxesWidth = this.get("yAxisOrient") == "right" ? 0 : this.get("yAxesLabelWidth") + 2;
            }
            yAxesWidth = this._isVerticalBar() || this._options.chart === "lineChart" ? this.axesLabelMarginValues() : yAxesWidth;
            this._container.style("margin-left", yAxesWidth + "px");
        } else {
            if (!this._isBubbleChart()) d3.select(chartContainer).style("height", "calc(100% - " + legendHeight + "px)");
            if (this._isBubbleChart()) {
                var topLegendHeight = 20;
                if (this.checkViewIsGrid()) d3.select(chartContainer).style("height", "calc(100% - " + topLegendHeight + "px)");
            }
        }
    }

    this.set("legendContainer", this._container);
};

/**
 * @method axesLabelMarginValues
 * @desc determine axes layout return margin left of top legend
 * @return {Float}
 */
Legend.prototype.axesLabelMarginValues = function () {
    // one left, one right, one left/one right, two left, two right
    //vert-bar: left axis, no label || no label X top || show X labels || right axis || double axes no label || double axes left right || double axes right = 0
    if (this._isVerticalBar() && !this.get("y1AxisLabel") && this.get("y1AxisOrient") == "left") return 0;
    if (this._isVerticalBar() && this.get("y1AxisOrient") == "right") return 4;

    if (!this.get("y1AxisLabel") && !this.get("y2AxisLabel") && this.get("y1AxisOrient") == "left" || this.get("y1AxisOrient") == "right" && (this.get("y2AxisOrient") == "right" || !this.get("y2"))) return 0;
    if (!this.get("y1AxisLabel") && this.get("y1AxisOrient") == "right" && !this.get("y2")) return 3;
    if (this.get("y1AxisOrient") == "right" || this.get("y2") && this.get("y2AxisOrient") == "right" && this.get("y1AxisOrient") == "right") return 4;
    return 15;
};

/**
 * @method adjustLegendHeight
 * @desc adjusts the legend height after the chart has been rendered
 * used within time-series chart currently
 */
Legend.prototype.adjustLegendHeight = function () {
    var container = this.get("selection").selectAll("." + Classes.LEGEND);
    var canvas = this.get("canvas");

    if (container.classed(Classes.LEGEND + "-right")) {
        container.style({
            height: canvas.height() + "px"
        });
    }
};

/**
 * @method adjustLegendWidth
 * @desc adjusts the legend height after the chart has been rendered
 * used within time-series chart currently
 */
Legend.prototype.adjustLegendWidth = function (textWidth) {
    var canvas = this._canvas;
    var parentID = this.get('parentID');
    var chartContainer = canvas.get("container");
    var isTimeSeries = this._options.chart === "time-series";
    var scrollbarWithPadding = 17;
    var iconWidth = 40;
    var legendMarginPad = 13;
    var legendHeight = typeof this._container[0][0].children[0] !== 'undefined' ? this._container[0][0].children[0].clientHeight : this._container[0][0].offsetHeight - this._margin.bottom - this._margin.top - 1; // subtract 1 to align bottom rule

    if ((this._isScatterPlot() || this._isBubbleChart()) && typeof this._container[0][0].children[1] !== 'undefined' && this._container[0][0].children[1] != null) {
        legendHeight = typeof this._container[0][0].children[1].children[0] !== 'undefined' ? this._container[0][0].children[1].children[0].clientHeight : legendHeight;
    }
    if (this._container.classed(Classes.LEGEND + "-right")) {
        var legendMaxWidth = this._legendMaxWidth;
        legendHeight = isTimeSeries ? legendHeight - 10 : legendHeight;
        if (legendHeight > this._container[0][0].offsetHeight || this._isScatterPlot() || this._isBubbleChart() && canvas.height() - 9 < legendHeight) {
            //Scrollbar space
            textWidth = textWidth + scrollbarWithPadding;
            if (isTimeSeries) {
                d3.select(this._container[0][0].children[0]).attr('width', (textWidth || 15) - 15 + 'px');
            } //show item line full width of container
        }
        textWidth = textWidth > legendMaxWidth ? legendMaxWidth : textWidth;

        this._container.style("width", textWidth + "px");
        var newLegendWidth = this.get("selection")[0][0].offsetWidth - textWidth - legendMarginPad;
        var chartWidth = this._isScatterPlot() ? newLegendWidth + 2 : newLegendWidth;

        d3.select(chartContainer).style("width", chartWidth + "px");
        this.set("legendWidth", textWidth);
        if (!this._isScatterPlot() && this._data[0].groupName !== "benchmark" && !this._isBubbleChart()) {
            this._legend.style("height", legendHeight + "px");
            this._container.style({
                height: canvas.height() - 5 + "px", //SVG Specific
                width: textWidth + "px",
                "margin-top": canvas.get("margin").top + "px" //SVG Specific
            });

            chartContainer = d3.select(canvas.get("container"));
            var chartWidth = chartContainer.node().clientWidth;

            //calc was not working properly on IE 11, set width based on client instead
            chartContainer.style("width", "calc(100% - " + textWidth + "px)");
        }

        if (this._isBubbleChart()) {
            var legendContainerHeight = !this.checkViewIsGrid() ? canvas.height() + 20 : canvas.height() - 9;
            if (this._container[0][0].childNodes[1]) {
                legendContainerHeight = this.checkViewIsGrid() ? legendContainerHeight - 19 : legendContainerHeight;
                d3.select(this._container[0][0].childNodes[1]).style({
                    height: legendContainerHeight + "px"
                });
            }
        }
    } else {
        chartContainer = d3.select(canvas.get("container"));
        var chartWidth = chartContainer.node().clientWidth;
        if (this._isBubbleChart()) {
            chartContainer.style({
                width: "100%"
            });
        }
        d3.select("#svgcontainer_" + parentID).select("svg").attr("width", chartWidth - iconWidth - 8); //overflow button - medium space
    }
};

/**
  * @method _color
  * Returns the index *n* color from the *colors* attribute array
  * @param {Number} index Index of color to return
  * scatterplot uses plot colors different array than colors
  * @return {Array}
  */
Legend.prototype._color = function (index) {
    var plotColors;
    var colors = this.get("colors");
    if (this.get("plotColors")) {
        if (this.get("plotColors").length === 0) {
            plotColors = [colors[0], colors[2]];
        }
        plotColors = plotColors.concat(colors.slice(3));
        this.set("scatterplotColors", plotColors);
        return plotColors[index % plotColors.length];
    }
    return colors[index % colors.length];
};

/**
  * @method _isDottedLine
  * Returns whether current key is dotted line
  * @param {String} group Chart group set
  * @param {String} name Current data value name
  * when adding legend item determines whether a {background-color, dotted line, or border} needed
  * @return {Boolean}
  */
Legend.prototype._isDottedLine = function (group, name) {
    if (this.get("dottedLineNames")) {
        var dottedLineNames = !(this._isScatterPlot(group) || group === "benchmark") ? this.get("dottedLineNames")[group] : null;
        if (dottedLineNames instanceof Array) {
            return dottedLineNames.indexOf(name) > -1;
        } else {
            return dottedLineNames;
        }
    }
    return group === "benchmark" && this._benchmarkStyle;
};

/**
  * @method _isScatterPlot
  * Returns whether chart option is scatterplot
  * @return {Boolean}
  */
Legend.prototype._isScatterPlot = function () {
    return this._options.chart === "scatterplot";
};

Legend.prototype._isVerticalBar = function () {
    return this._options.chart === "verticalBar";
};

/**
  * @method _isBubbleChart
  * Returns whether chart option is bubbleChart
  * @return {Boolean}
  */
Legend.prototype._isBubbleChart = function () {
    return this._options.chart === "bubbleChart";
};

/**
  * @method _isBenchmark
  * Returns whether current data is in benchmark group
  * @return {Boolean}
  */
Legend.prototype._isBenchmark = function (groupName) {
    return groupName === "benchmark";
};

/**
 * @method sortLegendData
 * @param {Array} groups
 * @desc Takes an array of group names and creates a new data object sorted in descending order by value
 * @return {Array} sortedArray
 */
Legend.prototype._sortLegendData = function () {
    var dataManager = this.get("data");
    var sortedArr = [];

    var _this = this;
    var addLegendSet = function addLegendSet(group) {
        group.forEach(function (dataset) {
            var value = _this.getValidEndValue(dataset.series);
            var displayName = dataset.displayName;
            var index = dataset.index;
            sortedArr.push({ value: value, displayName: displayName, index: index });
        });
    };

    var y1DomainDataset = this.get("y1DomainDataset");
    var groups = [y1DomainDataset];
    if (this.get("y2")) {
        var y2DomainDataset = this.get("y2DomainDataset");
        groups = groups.concat(y2DomainDataset);
    }

    groups.forEach(function (name) {
        addLegendSet(dataManager.get(name));
    });

    // sort legend items by the end value of series line
    sortedArr = this.sortDataByEndValue(sortedArr);

    return sortedArr;
};

/**
 * Used to display the legend after having been removed
 */
Legend.prototype.addLegend = function () {
    if (this.get("showLegend") === false) {
        this.set("showLegend", true);
        this.update();
    }
};
/**
 * To remove the legend after having been rendered
 */
Legend.prototype.removeLegend = function () {
    this.set("showLegend", false);
    this.set("legendCreated", false);
    this.update();
};

/**
 * Mouse Listeners
 */
Legend.prototype.legendFocusIn = function (group) {
    this.get("legendContainer").selectAll(".legend-item").filter(function () {
        return !d3.select(this).classed(group);
    }).classed("unfocused", true);
};

Legend.prototype.legendFocusOut = function () {
    this.get("legendContainer").selectAll(".legend-item").classed("unfocused", false);
};

Legend.prototype.legendMouseover = function (d) {
    var group = Utils.string.dashify(d.name);
    var canvas = this.get("canvas");
    canvas.layer("chart-layer").selectAll("g.dot").filter(function () {
        return !d3.select(this).classed(group);
    }).classed({
        unfocused: true,
        less: true
    });
    canvas.layer(this.getId("benchmark"), "front").select("rect").classed({
        unfocused: true
    });
    this.legendFocusIn(group);
};

Legend.prototype.legendMouseout = function () {
    var canvas = this.get("canvas");
    canvas.layer("chart-layer").selectAll("g.dot").classed({
        unfocused: false,
        less: false
    });
    canvas.layer(this.getId("benchmark"), "front").select("rect").classed({
        unfocused: false
    });
    this.legendFocusOut();
};

Legend.prototype.getLegendWidth = function (container, data) {
    var svg = container.append("svg");
    var width = Utils.svg.getGreaterSVGTextWidth(svg, data, "displayName");
    svg.remove();
    return width;
};

Legend.prototype.legendBenchmarkMouseover = function (d) {
    var canvas = this.get("canvas");
    canvas.layer("chart-layer").selectAll("g.dot").classed({
        unfocused: true,
        less: true
    });
    canvas.layer(this.getId("benchmark"), "front").select("rect").classed({
        focused: true
    });
    this.legendFocusIn("benchmark");
};

Legend.prototype.legendBenchmarkMouseout = function () {
    var canvas = this.get("canvas");
    canvas.layer("chart-layer").selectAll("g.dot").classed({
        unfocused: false,
        less: false
    });
    canvas.layer(this.getId("benchmark"), "front").select("rect").classed({
        focused: false
    });
    this.legendFocusOut();
};

module.exports = Legend;

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = {"constants":{"color":{"white":"#ffffff","black":"#000000","neutral":{"12":"#1e1e1e","20":"#333333","37":"#5e5e5e","50":"#808080","67":"#ababab","80":"#cccccc","90":"#e5e5e5","95":"#f2f2f2"},"blue":{"23":"#004376","32":"#005ba1","36":"#006fba","38":"#1f55a5","41":"#0077cf","44":"#008dde"},"green":{"34":"#00af41"},"dark-green":{"34":"#518428"},"teal":{"19":"#005f5f"},"violet":{"46":"#6a4c9e"},"cyan":{"44":"#00a8e1"},"maroon":{"32":"#a50032"},"red":{"50":"#ff0000"},"yellow":{"48":"#f5c400"},"orange":{"54":"#ef7622"},"light-red":{"46":"#e60546"},"dark-violet":{"32":"#7d256f"},"dark-yellow":{"47":"#c19c31"},"aqua":{"37":"#00beaf"},"bright-orange":{"50":"#ff3c00"},"light-green":{"50":"#89bd40"}},"brand":{"blue":"#1f55a5","cyan":"#00a8e1"},"background-color":{"default":"#ffffff","light":"#f2f2f2","dark":"#1e1e1e","black":"#000000","alternative-row":{"default":"#e5e5e5","on-light":"#e5e5e5","on-dark":"#333333"},"feedback":{"error":"#ff0000","warning":"#f5c400"}},"text-color":{"primary":{"default":"#1e1e1e","on-light":"#1e1e1e","on-dark":"#ffffff"},"secondary":{"default":"#5e5e5e","on-light":"#5e5e5e","on-dark":"#ababab"},"link":{"default":"#006fba","on-light":"#006fba","on-dark":"#008dde"},"error":{"default":"#ff0000","on-light":"#ff0000","on-dark":"#ff0000"}},"interactive-color":{"primary":{"default":"#0077cf","hover":"#005ba1","focus":"#005ba1","active":"#004376"},"secondary":{"primary":"transparent","hover":"#5e5e5e","focus":"#5e5e5e","active":{"on-light":"#333333","on-dark":"#e5e5e5"}},"disabled":{"on-light":"#808080","on-dark":"#ababab"}},"visualization-color":{"asset-allocation":{"local-stocks":"#1f55a5","non-local-stocks":"#8faad2","stocks":"#1f55a5","real-estate":"#a50032","other":"#f5c400","cash":"#518428","bonds":"#ef7622","not-classified":"#e5e5e5"},"correlation":{"positive":"#1f55a5","negative":"#ef7622"},"sector":{"cyclical":"#ef7622","sensitive":"#1f55a5","defensive":"#518428"},"sustainability":"#1f55a5","valuation":{"under":"#00a8e1","fair":"#e5efef","over":"#ef7622"},"performance":{"positive":"#00af41","neutral-text":"#5e5e5e","neutral-chart":"#cccccc","negative":"#ff0000"}},"chart-color":{"1":"#1f55a5","2":"#a50032","3":"#f5c400","4":"#518428","5":"#00a8e1","6":"#6a4c9e","7":"#ef7622","8":"#005f5f","9":"#00af41","10":"#e60546","11":"#7d256f","12":"#c19c31","13":"#00beaf","14":"#ff3c00","15":"#89bd40"},"feedback-color":{"info":"#f2f2f2","error":"#ff0000","error-background":"#ffe5e5","warning":"#f5c400","warning-background":"#fef9e5","success":"#00af41","success-background":"#e5f7eb"},"font":{"family":{"sans-serif":"'Univers', HelveticaNeue, 'Helvetica Neue', Helvetica, Arial, sans-serif","monospace":"'Lucida Sans Typewriter', 'Lucida Console', monaco, 'Bitstream Vera Sans Mono', monospace"},"weight":{"thin":200,"light":300,"regular":400,"bold":600},"size":{"xs":"10px","s":"14px","m":"16px","l":"20px","base":"16px","default":"16px","heading-level-1":"45px","heading-level-2":"32px","heading-level-3":"28px","heading-level-4":"23px","heading-level-5":"20px","heading-level-6":"18px","code":"12px"},"line-height":{"headings":1.2,"body":1.375}},"border":{"separator":{"default":"solid 1px #e5e5e5","on-light":"solid 1px #cccccc","on-dark":"solid 1px #333333","on-title":"solid 2px #333333","color-on-light":"#cccccc","color-on-dark":"#333333"},"control":{"default":"solid 1px #808080","color":"#808080"},"container":{"default":"solid 1px #e5e5e5","color-default":"#e5e5e5"},"disabled":"solid 1px #808080","radius":{"panel":"12px","pill":"24px","round":"50%","s":"2px"}},"size":{"icon":{"s":"15px","m":"23px"}},"space":{"xs":"4px","s":"6px","m":"8px","l":"12px","xl":"16px","quarter-x":"2px","half-x":"4px","three-quarter-x":"6px","1-x":"8px","1-and-a-half-x":"12px","2-x":"16px","3-x":"24px","4-x":"32px","8-x":"64px","inset":{"xs":"4px","s":"6px","m":"8px","l":"12px","xl":"16px","quarter-x":"2px","half-x":"4px","three-quarter-x":"6px","1-x":"8px","1-and-a-half-x":"12px","2-x":"16px","3-x":"24px","4-x":"32px","8-x":"64px","stretch":{"s":"6px 12px","m":"8px 16px","l":"12px 24px"}},"inline-left":{"xs":"0 4px 0 0","s":"0 6px 0 0","m":"0 8px 0 0","l":"0 12px 0 0","xl":"0 16px 0 0","half-x":"0 4px 0 0","three-quarter-x":"0 6px 0 0","1-x":"0 8px 0 0","1-and-a-half-x":"0 12px 0 0","2-x":"0 16px 0 0"},"inline-right":{"xs":"0 0 0 4px","s":"0 0 0 6px","m":"0 0 0 8px","l":"0 0 0 12px","xl":"0 0 0 16px","half-x":"0 0 0 4px","three-quarter-x":"0 0 0 6px","1-x":"0 0 0 8px","1-and-a-half-x":"0 0 0 12px","2-x":"0 0 0 16px"},"stack":{"s":"0 0 6px","m":"0 0 8px","l":"0 0 12px","xl":"0 0 16px","quarter-x":"0 0 2px","half-x":"0 0 4px","three-quarter-x":"0 0 6px","1-x":"0 0 8px","1-and-a-half-x":"0 0 12px","2-x":"0 0 16px","3-x":"0 0 24px","4-x":"0 0 32px","8-x":"0 0 64px"}},"transition":{"color":{"link":"color, 300ms"}},"opacity":{"disabled":".4","overlay":".5"},"box-shadow":{"drop":"0 2px 4px 0 rgba(0, 0, 0, .08)","focus":"0 0 4px 2px rgba(#0077cf, .8)"},"z-index":{"low":1,"sticky":100,"modal-overlay":800,"modal-content":810,"top-of-the-world":900},"breakpoint":{"navigation":{"on-canvas-nav":"768px","wide":"1024px"}},"masthead":{"height":"50px","height-tall":"70px"},"site-navigation":{"height":"50px","vertical-width":"230px"}},"shared":[{"utils":true},{"color":true},{"fonts":true},{"accessibility":true},{"animation":true},{"size":true},{"bubbles":true},{"typography":true}],"components":[{"link":true},{"icon":true},{"button":true},{"button_group":true},{"card":true},{"navigation_container":true},{"container":true},{"data_table":true},{"dialog":true},{"form":true},{"combo_box":true},{"list_group":true},{"loader":true},{"modal":true},{"menu":true},{"notification":true},{"pagination":true},{"page_shell":true},{"popover":true},{"range_slider":true},{"search_field":true},{"stepper":true},{"switch":true},{"tag":true},{"tooltip":true},{"masthead":true},{"site_navigation":true},{"alert":true},{"top_hat":true},{"layout_grid":true}],"theme":"mds"}

/***/ })

/******/ });
});